import { render, staticRenderFns } from "./OpcEstatal.vue?vue&type=template&id=361037c6&scoped=true"
var script = {}
import style0 from "./OpcEstatal.vue?vue&type=style&index=0&id=361037c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361037c6",
  null
  
)

export default component.exports